import { render, staticRenderFns } from "./ReceiptPdfSettingsDialog.vue?vue&type=template&id=4009c20a&scoped=true&"
import script from "./ReceiptPdfSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./ReceiptPdfSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPdfSettingsDialog.vue?vue&type=style&index=0&id=4009c20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009c20a",
  null
  
)

export default component.exports